export default {
  dalmore: {
    title: '大摩珍稀威士忌俱樂部',
    agreement: {
      brand: '大摩珍稀威士忌俱樂部',
      title: '理性飲酒同意書',
      content:
        '感謝您蒞臨大摩尊榮貴賓活動。為了讓您有個美好的品酩體驗，請您與我們一同遵守「理性飲酒」規定。並以愉快、輕鬆的心情體驗活動，感謝您的配合。',
      agreementTerm: [
        '我已年滿 18 歲，符合台灣法律規定之合法飲酒年齡，並願意配合出示身分證明文件。',
        '我不會有過量飲酒或酒醉失態的情事而影響其他參與盛會之來賓。',
        '有心臟病、高血壓的來賓及懷孕婦女，請勿飲酒。',
        '飲酒前及飲酒中請進食，請勿空腹飲酒。',
        '配合台灣政府禁菸規定，會場內全面禁止吸菸。',
        '尊重生命及理性飲酒，我不會在飲酒後自行開車或騎車，將使用計程車，代駕服務/指定駕駛或是乘坐大眾運輸系統離開。',
      ],
      memberTerm1:
        '我已閱讀以上內容，並完全理解相關的要求與規定，我同意遵守上述規範參與活動。主辦單位將保留婉拒不遵守上述規範之來賓入場權利，同時不做任何退款或任何方式補償。',
      memberTerm2:
        '本人已充分知悉以下個資告知事項，尚格酒業依據《個人資料保護法》(暨施行細則)，向您告知本會員系統蒐集、處理及利用個人資料之事項：本會員系統依據個資法蒐集、處理及利用您的個人資料包含識別個人姓名、性別、出生日期、行動電話及電子郵件等。上述個人資料之蒐集、處理及利用，我們將作為會員服務及行銷、會員資料管理之執行、處理及利用等用途，並遵守個資法之規定妥善保護您的個人資訊。依據個資法第3條規定，您可向尚格酒業行使之個資權利包括：查詢、閱覽、複製、補充、更正、處理、利用及刪除。您可與尚格酒業聯繫，我們將儘速處理與回覆您的請求。您亦可拒絕提供相關之個人資料，但若無完整的資料，尚格酒業將無法進行本會員系統之後續作業，致無法提供您完整服務。',
      portraitTerm:
        '本人同意並授權尚格酒業拍攝、修飾、使用、公開展示本人之肖像，由拍攝者使用於尚格酒業所舉辦之活動影片社群露出中。本人同意上述著作(內含上述授權之肖像)，該拍攝者就該攝影著作享有完整之著作權。',
      memberTerm3: '我同意獲得大摩相關行銷活動訊息',
      memberTerm4: '即刻加入大摩珍稀俱樂部會員',
    },
  },
  jura: {
    title: '尚格珍稀威士忌俱樂部',
    agreement: {
      brand: '尚格珍稀威士忌俱樂部',
      title: '理性飲酒同意書',
      content:
        '非常感謝您蒞臨吉拉尊榮貴賓活動。為了讓您有個美好的品酩體驗，請您與我們一同遵守「理性飲酒」規定。並以愉快、輕鬆的心情體驗活動，感謝您的配合。',
      agreementTerm: [
        '我已年滿 18 歲，符合台灣法律規定之合法飲酒年齡，並願意配合出示身分證明文件。',
        '我不會有過量飲酒或酒醉失態的情事而影響其他參與盛會之來賓。',
        '有心臟病、高血壓的來賓及懷孕婦女，請勿飲酒。',
        '飲酒前及飲酒中請進食，請勿空腹飲酒。',
        '配合台灣政府禁菸規定，會場內全面禁止吸菸。',
        '尊重生命及理性飲酒，我不會在飲酒後自行開車或騎車，將使用計程車，代駕服務/指定駕駛或是乘坐大眾運輸系統離開。',
      ],
      memberTerm1:
        '我已閱讀以上內容，並完全理解相關的要求與規定，我同意遵守上述規範參與活動。主辦單位將保留婉拒不遵守上述規範之來賓入場權利，同時不做任何退款或任何方式補償。',
      memberTerm2:
        '本人已充分知悉以下個資告知事項，尚格酒業依據《個人資料保護法》(暨施行細則)，向您告知本會員系統蒐集、處理及利用個人資料之事項：本會員系統依據個資法蒐集、處理及利用您的個人資料包含識別個人姓名、性別、出生日期、行動電話及電子郵件等。上述個人資料之蒐集、處理及利用，我們將作為會員服務及行銷、會員資料管理之執行、處理及利用等用途，並遵守個資法之規定妥善保護您的個人資訊。依據個資法第3條規定，您可向尚格酒業行使之個資權利包括：查詢、閱覽、複製、補充、更正、處理、利用及刪除。您可與尚格酒業聯繫，我們將儘速處理與回覆您的請求。您亦可拒絕提供相關之個人資料，但若無完整的資料，尚格酒業將無法進行本會員系統之後續作業，致無法提供您完整服務。',
      portraitTerm:
        '本人同意並授權尚格酒業拍攝、修飾、使用、公開展示本人之肖像，由拍攝者使用於尚格酒業所舉辦之活動影片社群露出中。本人同意上述著作(內含上述授權之肖像)，該拍攝者就該攝影著作享有完整之著作權。',
      memberTerm3: '我同意獲得尚格酒業相關行銷活動訊息',
      memberTerm4: '即刻加入尚格酒業珍稀俱樂部會員',
    },
  },
  fettercairn: {
    title: '尚格珍稀威士忌俱樂部',
    agreement: {
      brand: '尚格珍稀威士忌俱樂部',
      title: '理性飲酒同意書',
      content:
        '非常感謝您蒞臨費特肯尊榮貴賓活動。為了讓您有個美好的品酩體驗，請您與我們一同遵守「理性飲酒」規定。並以愉快、輕鬆的心情體驗活動，感謝您的配合。',
      agreementTerm: [
        '我已年滿 18 歲，符合台灣法律規定之合法飲酒年齡，並願意配合出示身分證明文件。',
        '我不會過量飲酒或酒醉失態而影響其他參與盛會之來賓。',
        '有心臟病、高血壓疾病的來賓及懷孕婦女，請勿飲酒。',
        '飲酒前及飲酒中請進食，請勿空腹飲酒。',
        '配合台灣政府禁菸規定，會場內全面禁止吸菸。',
        '尊重生命及理性飲酒，我不會在飲酒後自行開車或騎車，將使用計程車，代駕服務/指定駕駛或是乘坐大眾運輸系統離開。',
      ],
      memberTerm1:
        '我已閱讀以上內容，並完全理解相關的要求與規定，我同意遵守上述規範參與活動。主辦單位將保留婉拒不遵守上述規範之來賓入場權利，同時不做任何退款或任何方式補償。',
      memberTerm2:
        '本人已充分知悉以下個資告知事項，尚格酒業依據《個人資料保護法》(暨施行細則)，向您告知本會員系統蒐集、處理及利用個人資料之事項：本會員系統依據個資法蒐集、處理及利用您的個人資料包含識別個人姓名、性別、出生日期、行動電話及電子郵件等。上述個人資料之蒐集、處理及利用，我們將作為會員服務及行銷、會員資料管理之執行、處理及利用等用途，並遵守個資法之規定妥善保護您的個人資訊。依據個資法第3條規定，您可向尚格酒業行使之個資權利包括：查詢、閱覽、複製、補充、更正、處理、利用及刪除。您可與尚格酒業聯繫，我們將儘速處理與回覆您的請求。您亦可拒絕提供相關之個人資料，但若無完整的資料，尚格酒業將無法進行本會員系統之後續作業，致無法提供您完整服務。',
      portraitTerm:
        '本人同意並授權尚格酒業拍攝、修飾、使用、公開展示本人之肖像，由拍攝者使用於尚格酒業所舉辦之活動影片社群露出中。本人同意上述著作(內含上述授權之肖像)，該拍攝者就該攝影著作享有完整之著作權。',
      memberTerm3: '我同意獲得尚格酒業相關行銷活動訊息',
      memberTerm4: '即刻加入尚格酒業珍稀俱樂部會員',
    },
  },
  tamnavulin: {
    title: '尚格珍稀威士忌俱樂部',
    agreement: {
      brand: '尚格珍稀威士忌俱樂部',
      title: '理性飲酒同意書',
      content:
        '非常感謝您蒞臨塔木嶺尊榮貴賓活動。為了讓您有個美好的品酩體驗，請您與我們一同遵守「理性飲酒」規定。並以愉快、輕鬆的心情體驗活動，感謝您的配合。',
      agreementTerm: [
        '我已年滿 18 歲，符合台灣法律規定之合法飲酒年齡，並願意配合出示身分證明文件。',
        '我不會過量飲酒或酒醉失態而影響其他參與盛會之來賓。',
        '有心臟病、高血壓疾病的來賓及懷孕婦女，請勿飲酒。',
        '飲酒前及飲酒中請進食，請勿空腹飲酒。',
        '配合台灣政府禁菸規定，會場內全面禁止吸菸。',
        '尊重生命及理性飲酒，我不會在飲酒後自行開車或騎車，將使用計程車，代駕服務/指定駕駛或是乘坐大眾運輸系統離開。',
      ],
      memberTerm1:
        '我已閱讀以上內容，並完全理解相關的要求與規定，我同意遵守上述規範參與活動。主辦單位將保留婉拒不遵守上述規範之來賓入場權利，同時不做任何退款或任何方式補償。',
      memberTerm2:
        '本人已充分知悉以下個資告知事項，尚格酒業依據《個人資料保護法》(暨施行細則)，向您告知本會員系統蒐集、處理及利用個人資料之事項：本會員系統依據個資法蒐集、處理及利用您的個人資料包含識別個人姓名、性別、出生日期、行動電話及電子郵件等。上述個人資料之蒐集、處理及利用，我們將作為會員服務及行銷、會員資料管理之執行、處理及利用等用途，並遵守個資法之規定妥善保護您的個人資訊。依據個資法第3條規定，您可向尚格酒業行使之個資權利包括：查詢、閱覽、複製、補充、更正、處理、利用及刪除。您可與尚格酒業聯繫，我們將儘速處理與回覆您的請求。您亦可拒絕提供相關之個人資料，但若無完整的資料，尚格酒業將無法進行本會員系統之後續作業，致無法提供您完整服務。',
      portraitTerm:
        '本人同意並授權尚格酒業拍攝、修飾、使用、公開展示本人之肖像，由拍攝者使用於尚格酒業所舉辦之活動影片社群露出中。本人同意上述著作(內含上述授權之肖像)，該拍攝者就該攝影著作享有完整之著作權。',
      memberTerm3: '我同意獲得尚格酒業相關行銷活動訊息',
      memberTerm4: '即刻加入尚格酒業珍稀俱樂部會員',
    },
  },
}
